<template>
  <Modal
    ref="modalOccupationsUpload"
    :title="$t('OccupationsService.Modal.title')"
    width="60%"
    :zIndex="999"
    :has-tab="false"
  >
    <template v-slot:[`no-tab`]>
      <div class="modal-upload">
        <div class="modal-upload-info" v-show="!showForm && !loading">
          <p>
            {{ $t('OccupationsService.Modal.headerInstruction') }}
          </p>
          <a href="/modelo.xlsx" download>{{
            $t('OccupationsService.Modal.downloadSheets')
          }}</a>
        </div>

        <AddFile @file="validateFile" :label="fileName" />

        <div v-if="showForm">
          <span class="modal-upload-subtitle">
            {{ $t('OccupationsService.Modal.subtitle') }}
          </span>
          <v-divider></v-divider>
        </div>

        <div v-if="loading" class="loading">
          <v-progress-circular indeterminate color="primary" />
        </div>

        <v-container fluid v-if="showForm">
          <v-radio-group v-model="action" inline class="modal-upload-action">
            <v-radio
              :label="$t('OccupationsService.Modal.labels.action.addUpdate')"
              :value="OCCUPATIONS_ACTIONS.AddUpdate"
            ></v-radio>
            <v-radio
              :label="$t('OccupationsService.Modal.labels.action.delete')"
              :value="OCCUPATIONS_ACTIONS.Delete"
            ></v-radio>
          </v-radio-group>
        </v-container>

        <v-form
          ref="form"
          @submit.prevent
          v-show="showForm"
          class="modal-upload-form"
          v-model="valid"
        >
          <v-container>
            <div class="single-input">
              <SingleSelection
                :selectedItem="selectedTab"
                :label="$t('OccupationsService.Modal.labels.selectTab')"
                :placeholder="$t('OccupationsService.Modal.labels.selectTab')"
                :items="tabs"
                @selectOption="handleTabSelection"
              />
            </div>
            <div
              v-if="selectedTab && action === OCCUPATIONS_ACTIONS.AddUpdate"
              class="inline-inputs"
            >
              <div class="input-holder">
                <SingleSelection
                  :label="$t('OccupationsService.Modal.labels.selectIdColumn')"
                  :placeholder="
                    $t('OccupationsService.Modal.labels.selectIdColumn')
                  "
                  :items="occupationsColumns"
                  @selectOption="handleSelectOption($event, 'id')"
                />
              </div>
              <div class="input-holder">
                <SingleSelection
                  :label="
                    $t('OccupationsService.Modal.labels.selectTitleColumn')
                  "
                  :placeholder="
                    $t('OccupationsService.Modal.labels.selectTitleColumn')
                  "
                  :items="occupationsColumns"
                  @selectOption="handleSelectOption($event, 'title')"
                />
              </div>
              <div class="input-holder">
                <SingleSelection
                  :label="
                    $t(
                      'OccupationsService.Modal.labels.selectDescriptionColumn'
                    )
                  "
                  :placeholder="
                    $t(
                      'OccupationsService.Modal.labels.selectDescriptionColumn'
                    )
                  "
                  :items="occupationsColumns"
                  :rules="[rules.required]"
                  @selectOption="handleSelectOption($event, 'description')"
                />
              </div>
            </div>
            <div
              v-if="selectedTab && action === OCCUPATIONS_ACTIONS.Delete"
              class="inline-inputs"
            >
              <div class="input-holder">
                <SingleSelection
                  :label="$t('OccupationsService.Modal.labels.selectIdColumn')"
                  :placeholder="
                    $t('OccupationsService.Modal.labels.selectIdColumn')
                  "
                  :items="occupationsColumns"
                  :rules="[rules.required]"
                  @selectOption="handleSelectOption($event, 'id')"
                />
              </div>
            </div>
          </v-container>
        </v-form>

        <v-divider v-show="showForm && selectedTab"></v-divider>

        <div class="dialog-footer" v-show="showForm && selectedTab">
          <v-btn
            @click="handleDialog()"
            class="dialog-footer-btnCancel"
            depressed
            plain
          >
            {{ $t('OccupationsService.modalButtons.cancel') }}
          </v-btn>

          <v-btn
            @click="SendTabsInformations"
            class="dialog-footer-btn"
            depressed
          >
            {{ _buttonLabel }}
          </v-btn>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>
import { OCCUPATIONS_ACTIONS } from '@/helpers/upload-actions'
import AddFile from '@/views/SyncPage/Tabs/DataPage/Tabs/PeoplePage/Partials/UploadModal/Partials/AddFile/AddFile.vue'
import {
  verifySpreadSheet,
  sendTabsInformations,
} from '@/services/occupations/index'

export default {
  components: {
    AddFile,
  },
  data() {
    return {
      OCCUPATIONS_ACTIONS,
      action: OCCUPATIONS_ACTIONS.AddUpdate,
      showForm: false,
      fileName: '',
      loading: false,
      columns: {},
      tabsInformations: {
        fileLocationId: '',
        tab: {
          name: '',
          columns: [],
        },
      },
      selectedTab: '',
      valid: false,
      rules: {
        required: v => {
          const requiredLabel = this.$t(
            'OccupationsService.Modal.requiredField'
          )

          if (v instanceof Array && v.length == 0) return requiredLabel
          return !!v || requiredLabel
        },
      },
    }
  },
  watch: {
    selectedTab() {
      this.reset()
    },
  },
  computed: {
    tabs() {
      return this.columns.tabs?.map(el => el.name)
    },
    occupationsColumns() {
      return this.columns?.tabs?.find(el => el.name === this.selectedTab)
        .columns
    },
    _buttonLabel() {
      return this.action === OCCUPATIONS_ACTIONS.AddUpdate
        ? this.$t('OccupationsService.modalButtons.loadOccupations')
        : this.$t('OccupationsService.modalButtons.deleteOccupations')
    },
  },
  methods: {
    initiliazeData() {
      this.action = OCCUPATIONS_ACTIONS.AddUpdate
      this.showForm = false
      this.fileName = ''
      this.columns = {}
      this.selectedTab = ''
      this.tabsInformations = {
        fileLocationId: '',
        tab: {
          name: '',
          columns: [],
        },
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    handleDialog() {
      this.initiliazeData()
      this.$refs.modalOccupationsUpload.handleDialog()
    },
    handleTabSelection({ value }) {
      this.selectedTab = value
      this.tabsInformations.tab.name = value
    },
    handleSelectOption({ value }, name) {
      const columnWithAtributte = {
        column: value,
        attribute: name,
      }

      this.tabsInformations.tab.columns.push(columnWithAtributte)
    },
    async validateFile(file) {
      this.loading = true
      if (file) {
        this.fileName = file.name
        await verifySpreadSheet(file)
          .then(response => {
            this.loading = false
            this.showForm = true
            this.columns = response.data
          })
          .catch(error => {
            this.loading = false
            this.fileName = ''
            this.showForm = false
            this.$emit('alert', {
              type: 'error',
              message: error?.response?.data?.message || this.$t('uploadError'),
            })
          })
      }
    },
    async SendTabsInformations() {
      this.$refs.form.validate()
      if (!this.valid) {
        return
      }

      this.tabsInformations.action = this.action
      this.tabsInformations.fileLocationId = this.columns.fileLocationId

      this.loading = true
      this.showForm = false

      await sendTabsInformations(this.tabsInformations)
        .then(response => {
          this.$emit('alert', {
            type: 'success',
            message: response.data.message,
          })
          this.loading = false
          this.$emit('updateOccupationsList')
          this.handleDialog()
        })
        .catch(error => {
          this.loading = false
          this.showForm = true
          this.$emit('alert', {
            type: 'error',
            message: error.response.data.message,
          })
        })
    },
  },
}
</script>

<style src="./style.scss" lang="scss" scoped></style>
